<template>
<div>
    <span class="field-label font-B-container">
        first name
    </span>
    <input class="input-field" type="text" id="sFirstName" name="sFirstName" placeholder="first name" v-model="sFirstName">
</div>
</template>

<script>

export default {
  name: "FieldFirstName"
}

</script>

<style scoped>

</style>